import { Link as RouterLink } from "react-router-dom";

import { BREADCRUMB_TEXT_SX } from "ui/breadcrumbs/breadcrumbs.styles";
import { type BreadcrumbItem } from "ui/breadcrumbs/breadcrumbs.types";
import { Link } from "ui/link/link";
import { Typography } from "ui/typography/typography";

type BreadcrumbProps = Omit<BreadcrumbItem, "key">;

export const Breadcrumb = ({ label, href, kind }: BreadcrumbProps) => {
  if (kind === "link") {
    return (
      <Link component={RouterLink} to={href} size="small" underline="hover">
        {label}
      </Link>
    );
  }

  if (kind === "current") {
    return (
      <Typography component="span" variant="body2" aria-current="page" sx={BREADCRUMB_TEXT_SX.current}>
        {label}
      </Typography>
    );
  }

  return (
    <Typography component="span" variant="body2" sx={BREADCRUMB_TEXT_SX.text}>
      {label}
    </Typography>
  );
};
